// Double-brace variable tokens (pills), excluding triple-brace `{{{blocks}}}`.
// Mirrors the pill order that templateToPills produces, so the Nth match here
// corresponds to the Nth `.sd-variable-pill` in the rendered DOM.
const PILL_TOKEN_RE = /\{\{(?!\{)\s*([^{}]+?)\s*\}\}(?!\})/g;

/**
 * Replaces the token name of the pill at `index` (0-based, in document order)
 * within a stored content template, leaving all other tokens and any
 * triple-brace HTML blocks untouched. Returns the content unchanged when the
 * index is out of range.
 */
export const replacePillTokenAt = (
  content: string,
  index: number,
  nextToken: string,
): string => {
  let i = -1;
  return content.replace(PILL_TOKEN_RE, (match) => {
    i += 1;
    return i === index ? `{{${nextToken}}}` : match;
  });
};
